<template>
  <div>
    <div class="small">{{ $t('LoanApplicationTimeline.verificationIsNotSupportedInDesktop') }}</div>
    <div class="marketing">
      <a :href="appStoreLink">
        <img alt="Download on the App Store" :src="`/img/icons/badge-app-store-${language}.svg`" class="badge-ios"/>
      </a>
      <a :href="googlePlayLink">
        <img alt="Get it on Google Play" :src="`/img/icons/badge-google-play-${language}.png`" class="badge-android"/>
      </a>
    </div>
  </div>
</template>
<script>
import settings from '@shared/settings'
import i18n from '@shared/module/i18n'

export default {
  name: 'IdentityVerificationIsNotSupportedInDesktopComponent',
  data() {
    return {
      language: i18n.locale,
      country: settings.country(),
      iosAppStoreId: settings.iosAppStoreId(),
      androidAppPackageName: settings.androidAppPkgName()
    }
  },
  computed: {
    appStoreLink() {
      return `https://apps.apple.com/${this.country}/app/id${this.iosAppStoreId}`
    },
    googlePlayLink() {
      return `https://play.google.com/store/apps/details?id=${this.androidAppPackageName}`
    }
  }
}
</script>
<style>
.badge-ios {
  width: 240px;
  height: 54px;
  margin-left: -40px;
  margin-right: -20px;
}

.badge-android {
  height: 80px;
}
</style>
